<div style="width: 400px; height: 470px;" data-cy="duppatient-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="duppatient-header-section">
      <div class="section-header-title" data-cy="duppatient-title-text">
        User already exists:
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="duppatient-content-section">
      <div class="label" data-cy="duppatient-firstname-label"><b>First name:</b> </div><span data-cy="duppatient-firstname-value">{{data.ThePatient.dataContact.FirstName}}</span>
      <br />
      <div class="label" data-cy="duppatient-lastname-label"><b>Last name:</b> </div><span data-cy="duppatient-lastname-value">{{data.ThePatient.dataContact.LastName}}</span>
      <br />
      <div class="label" data-cy="duppatient-birthdate-label"><b>Birthdate:</b> </div><span data-cy="duppatient-birthdate-value">{{getFormattedDateString(data.ThePatient.dataContact.BirthDate)}}</span>
      <br *ngIf="ssNumEntered" />
      <div *ngIf="ssNumEntered" class="label" data-cy="duppatient-ssn-label"><b>SS Number:</b> </div><span *ngIf="ssNumEntered" data-cy="duppatient-ssn-value">{{data.ThePatient.dataContact.GovermentIdentificationNo2}}</span>
      <br />
      <br />
      <div *ngIf="!ssNumEntered" style="font-style: italic" data-cy="duppatient-ssn-notice">
        *In order to properly determine whether or not this new patient already exists in the system, we need their Social Security Number. Please enter the Social Security Number for the patient in the previous screen.
      </div>
      <div *ngIf="ssNumEntered" data-cy="duppatient-select-prompt">
        <b>Would you like to select this patient instead?</b>
      </div>

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="duppatient-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="duppatient-cancel-button">{{ ssNumEntered ? 'Cancel' : 'Ok' }}</button>
      <button *ngIf="ssNumEntered" (click)="selectPatient()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="duppatient-select-button">Ok</button>
    </div>
  </div>
</div>
